import { render, staticRenderFns } from "./AlertNotification.vue?vue&type=template&id=249f5d30"
import script from "./AlertNotification.vue?vue&type=script&lang=ts"
export * from "./AlertNotification.vue?vue&type=script&lang=ts"
import style0 from "./AlertNotification.vue?vue&type=style&index=0&id=249f5d30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports